import { useTranslation } from "react-i18next";

export default function LabelCalComponent(props) {
  const { t } = useTranslation();
  return (
    <div className="labelCalcDiv">
      <span className="labelCalcTitle">{t(props.title)}</span>
      <span className="labelCalAmountValue">$ {props.getLabelCalValue()}</span>
    </div>
  );
}
